export const BrandLogo = ({ brand, size = "h-10" }) =>
  brand.logo ? (
    <img src={brand.logo} alt={`Logo ${brand.name}`} loading="lazy" className={`${size} w-auto max-w-full object-contain`} />
  ) : (
    <span className="font-display font-extrabold text-sm uppercase text-neutral-700">{brand.name}</span>
  );

export function BrandGrid({ brands, onPick, q = "" }) {
  const list = brands.filter((b) => b.name.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2" data-testid="brand-grid">
      {list.map((b) => (
        <button key={b.name} onClick={() => onPick(b.name)} title={b.name}
          className="group bg-white/[0.96] hover:bg-white border-2 border-transparent hover:border-hp-yellow aspect-[4/3] flex flex-col items-center justify-center gap-1.5 p-2 transition-colors"
          data-testid={`brand-tile-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <div className="h-10 flex items-center justify-center transition-transform group-hover:scale-110"><BrandLogo brand={b} /></div>
          <span className="text-[10px] font-bold uppercase tracking-wide text-neutral-700 truncate max-w-full">{b.name}</span>
        </button>
      ))}
      {!list.length && <p className="col-span-full text-sm text-neutral-500 py-6">Aucune marque trouvée.</p>}
    </div>
  );
}
